import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "message-bubble-content" }
const _hoisted_2 = {
  key: 0,
  class: "message-body-nick-name"
}
const _hoisted_3 = { class: "content-main" }
const _hoisted_4 = {
  key: 1,
  class: "content-has-risk-tips"
}
const _hoisted_5 = {
  key: 0,
  class: "audio-unplay-mark"
}
const _hoisted_6 = { class: "message-bubble-feedback-button" }
const _hoisted_7 = {
  key: 1,
  class: "message-bubble-ai-note"
}
const _hoisted_8 = {
  key: 0,
  class: "message-bubble-extra-content"
}

import vue from '../../../../adapter-vue';
import TUIChatEngine, {
  TUITranslateService,
  IMessageModel,
} from '../../../../@aidesk/uikit-engine';
import Icon from '../../../common/Icon.vue';
import ReadStatus from './read-status/index.vue';
import MessageQuote from './message-quote/index-web.vue';
import Avatar from '../../../common/Avatar/index.vue';
import loadingIcon from '../../../../assets/loading.png';
import { canShowFeedback, shallowCopyMessage, canShowAINote } from '../../../../utils/utils';
import { isPC,isH5 } from '../../../../utils/env';
import { JSONToObject, isWelcomeMessage } from '../../../../utils/index';
import state from '../../../../utils/state.js';
import { CUSTOM_MESSAGE_SRC } from '../../../../constant';
import FeedbackButton from './feedback-button.vue';
import { ReadState } from '../../../../constant';
interface IProps {
  messageItem: IMessageModel;
  content?: any;
  classNameList?: string[];
  blinkMessageIDList?: string[];
  isAudioPlayed?: boolean | undefined;
  enableFeedback: number;
  enableAINote: number;
}

interface IEmits {
  (e: 'resendMessage'): void;
  (e: 'blinkMessage', messageID: string): void;
  // Only for uniapp
  (e: 'scrollTo', scrollHeight: number): void;
  (e: 'like', type: number, messageInfo: Object): void;
  (e: 'dislike', type: number, messageInfo: Object): void;
}

const riskImageReplaceUrl
  = 'https://web.sdk.qcloud.com/component/TUIKit/assets/has_risk_default.png';

export default /*@__PURE__*/_defineComponent({
  __name: 'message-bubble-web',
  props: {
    messageItem: { default: () => ({} as IMessageModel) },
    content: { default: () => ({}) },
    classNameList: { default: () => [] },
    blinkMessageIDList: { default: () => [] },
    isAudioPlayed: { type: Boolean, default: false },
    enableFeedback: { default: 0 },
    enableAINote: { default: 1 }
  },
  emits: ["resendMessage", "blinkMessage", "scrollTo", "like", "dislike"],
  setup(__props: any, { emit: __emit }) {

const { computed, toRefs } = vue;

const emits = __emit;

const props = __props;

const TYPES = TUIChatEngine.TYPES;
const needLoadingIconMessageType = [
  TYPES.MSG_LOCATION,
  TYPES.MSG_TEXT,
  TYPES.MSG_CUSTOM,
  TYPES.MSG_MERGER,
  TYPES.MSG_FACE,
];

const { blinkMessageIDList, messageItem: message } = toRefs(props);
const {
  showAvatar,
  showNickName,
  robotAvatar,
  memberAvatar,
  userAvatar,
  robotNickName,
  memberNickName,
  userNickName,
  enableUnifiedMemberProfile,
} = state.get('avatarNickName');
let prevStatus = ReadState.Unread;

const getCloudCustomData = () => {
  try {
    return JSONToObject(message.value.cloudCustomData);
  } catch (e) {
    return {};
  }
};
let cloudCustomData = getCloudCustomData();

const isDisplayUnplayMark = computed<boolean>(() => {
  return (
    message.value.flow === 'in'
    && message.value.status === 'success'
    && message.value.type === TYPES.MSG_AUDIO
    && !props.isAudioPlayed
  );
});

const containerClassNameList = computed(() => {
  return ['message-bubble', ...props.classNameList];
});

// When an emoji is deleted, the `reactionList` will update the corresponding emoji's `totalUserCount`.
const hasEmojiReaction = computed(() => {
  return message.value?.reactionList.some(
    (item: any) => item.totalUserCount !== 0,
  );
});

const isMultiBranchMsg = computed(()=>{
  if (message.value?.type == "TIMCustomElem") {
    const src = JSON.parse(message.value.payload.data).src;
    if (src === CUSTOM_MESSAGE_SRC.MULTI_BRANCH || src === CUSTOM_MESSAGE_SRC.BRANCH || src === CUSTOM_MESSAGE_SRC.BRANCH_NUMBER) {
      return true;
    }
  }
  return false;
});

const computedShowFeedback = computed(() => {
  return props.enableFeedback === 1 && !isWelcomeMessage(message.value) && canShowFeedback(message.value.cloudCustomData);
});

const computedShowAINote = computed(() => {
  return props.enableAINote === 1 && (state.get('currentLanguage') === 'zh' || state.get('currentLanguage') === 'en') && canShowAINote(message.value.cloudCustomData);
});

function isFromSeat() {
  return cloudCustomData.hasOwnProperty("role") && cloudCustomData.role === "seat";
}

const avatarUrl = computed(() => {
  let url = '';
  if (message.value.flow === 'in') {
    if (isFromSeat()) {
      if (enableUnifiedMemberProfile) {
        url = memberAvatar || message.value.avatar;
      } else if (cloudCustomData.memberInfo && cloudCustomData.memberInfo.memberAvatar) {
        url = cloudCustomData.memberInfo.memberAvatar
      } else {
        url = message.value.avatar;
      }
    } else {
      url = robotAvatar || message.value.avatar;
    }
  } else {
    url = userAvatar || message.value.avatar || '';
  }
  return url;
});

const nickName = computed(() => {
  let nick = '';
  if (message.value.flow === 'in') {
    if (isFromSeat()) {
      if (enableUnifiedMemberProfile) {
        nick = memberNickName || props.content.showName;
      } else if (cloudCustomData.memberInfo && cloudCustomData.memberInfo.memberNickName) {
        nick = cloudCustomData.memberInfo.memberNickName;
      } else {
        nick = props.content.showName;
      }
    } else {
      nick = robotNickName || props.content.showName;
    }
  } else {
    nick = userNickName || props.content.showName;
  }
  return nick;
});

const isProductCardOrOrderMessage = computed(() => {
  if (message.value?.type == "TIMCustomElem") {
    const src = JSON.parse(message.value.payload.data).src;
    if (src === CUSTOM_MESSAGE_SRC.PRODUCT_CARD || src === CUSTOM_MESSAGE_SRC.ORDER) {
      return true;
    }
  }
  return false;
});

const isNoPadding = computed(() => {
  return (
    !hasEmojiReaction.value
    && [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO, TYPES.MSG_MERGER].includes(
      message.value.type,
    )
  );
});

const riskContentText = computed<string>(() => {
  let content = TUITranslateService.t('TUIChat.涉及敏感内容') + ', ';
  if (message.value.flow === 'out') {
    content += TUITranslateService.t('TUIChat.发送失败');
  } else {
    content += TUITranslateService.t(
      message.value.type === TYPES.MSG_AUDIO
        ? 'TUIChat.无法收听'
        : 'TUIChat.无法查看',
    );
  }
  return content;
});

const isBlink = computed(() => {
  if (message.value?.ID) {
    return blinkMessageIDList?.value?.includes(message.value.ID);
  }
  return false;
});

function resendMessage() {
  if (!message.value?.hasRiskContent) {
    emits('resendMessage');
  }
}

function blinkMessage(messageID: string) {
  emits('blinkMessage', messageID);
}

function scrollTo(scrollHeight: number) {
  emits('scrollTo', scrollHeight);
}

function setStatus(status: ReadState) {
  prevStatus = status;
}
function onLike(type: number, messageInfo: Object) {
  emits('like', type, messageInfo);
}

function onDislike(type: number, messageInfo: Object) {
  emits('dislike', type, messageInfo);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(containerClassNameList))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({
        'control-reverse': _unref(message).flow === 'out',
      })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["message-bubble-main-content", [_unref(message).flow === 'in' ? '' : 'reverse']])
        }, [
          (_unref(showAvatar) === 1)
            ? (_openBlock(), _createBlock(Avatar, {
                key: 0,
                useSkeletonAnimation: "",
                url: _unref(avatarUrl)
              }, null, 8, ["url"]))
            : _createCommentVNode("", true),
          _createElementVNode("main", {
            class: _normalizeClass(['message-body',_unref(message).flow==='out' && 'message-body-reverse']),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_unref(showNickName) === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(nickName)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([
                'message-body-main',
                _unref(message).flow === 'out' && 'message-body-main-reverse',
              ])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
                  'blink',
                  'message-body-content',
                  _unref(message).flow === 'out' ? 'content-out' : 'content-in',
                  _unref(message).hasRiskContent && 'content-has-risk',
                  _unref(isNoPadding) ? 'content-no-padding' : '',
                  _unref(isNoPadding) && _unref(isBlink) ? 'blink-shadow' : '',
                  !_unref(isNoPadding) && _unref(isBlink) ? 'blink-content' : '',
                  _unref(isMultiBranchMsg)?'multi-branch-message':'',
                  (_unref(isProductCardOrOrderMessage) && _unref(isH5)) ? 'product-order-message-bubble-h5' : (_unref(isProductCardOrOrderMessage) ? 'product-order-message-bubble' : ''),
                  _unref(isPC) ? '':'body-mobile',
                ])
              }, [
                (_unref(isH5))
                  ? (_openBlock(), _createBlock(MessageQuote, {
                      key: 0,
                      class: _normalizeClass(_unref(message).flow === 'out' ? 'reverse' : 'flex-row'),
                      message: _unref(message),
                      onBlinkMessage: blinkMessage,
                      onScrollTo: scrollTo
                    }, null, 8, ["class", "message"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  (
                      (_unref(message).type === _unref(TYPES).MSG_IMAGE ||
                        _unref(message).type === _unref(TYPES).MSG_VIDEO) &&
                        _unref(message).hasRiskContent
                    )
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass([
                      'message-risk-replace',
                      !_unref(isPC) && 'message-risk-replace-h5',
                    ]),
                        src: riskImageReplaceUrl
                      }, null, 2))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _renderSlot(_ctx.$slots, "messageElement"),
                        _renderSlot(_ctx.$slots, "TUIEmojiPlugin")
                      ], 64))
                ]),
                (_unref(message).hasRiskContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(riskContentText)), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (_unref(isDisplayUnplayMark))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true),
              (_unref(message).status === 'fail' || _unref(message).hasRiskContent)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "message-label fail",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (resendMessage()))
                  }, " ! "))
                : _createCommentVNode("", true),
              (
                  _unref(message).status === 'unSend' &&
                    needLoadingIconMessageType.includes(_unref(message).type)
                )
                ? (_openBlock(), _createBlock(Icon, {
                    key: 2,
                    class: "message-label loading-circle",
                    file: _unref(loadingIcon),
                    width: '15px',
                    height: '15px'
                  }, null, 8, ["file"]))
                : _createCommentVNode("", true),
              _createVNode(ReadStatus, {
                class: "message-label align-self-bottom",
                message: _unref(shallowCopyMessage)(_unref(message)),
                onSetStatus: setStatus,
                prevStatus: _unref(prevStatus)
              }, null, 8, ["message", "prevStatus"])
            ], 2),
            _createElementVNode("div", _hoisted_6, [
              (_unref(computedShowFeedback))
                ? (_openBlock(), _createBlock(FeedbackButton, {
                    key: 0,
                    message: _unref(shallowCopyMessage)(_unref(message)),
                    onLike: onLike,
                    onDislike: onDislike
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              (_unref(computedShowAINote))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(TUITranslateService).t('AIDesk.该回复由AI生成，内容仅供参考')), 1))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2),
        (!_unref(isH5))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(MessageQuote, {
                class: _normalizeClass(_unref(message).flow === 'out' ? 'reverse' : 'flex-row'),
                message: _unref(message),
                onBlinkMessage: blinkMessage,
                onScrollTo: scrollTo
              }, null, 8, ["class", "message"])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 2))
}
}

})